(function () {
  var QUESTIONS = [
    {
      key: 'exigencia',
      question: '¿Qué tan exigente es el trabajo donde se usará el guante?',
      options: [
        { label: 'Ligero — tareas cortas, cambio frecuente', value: 'light' },
        { label: 'Moderado — uso diario, necesito buen agarre', value: 'moderate' },
        { label: 'Alta resistencia — manejo de objetos ásperos o cortantes', value: 'heavy' },
      ],
    },
    {
      key: 'alimentos',
      question: '¿Vas a manipular alimentos con este guante?',
      options: [
        { label: 'Sí, manipularé alimentos', value: 'si' },
        { label: 'No, es para otro uso', value: 'no' },
      ],
    },
    {
      key: 'latex',
      question: '¿Prefieres evitar el látex (por alergia o por seguridad de tu equipo)?',
      options: [
        { label: 'Sí, prefiero evitar el látex', value: 'evitar' },
        { label: 'No hay problema con el látex', value: 'no-problema' },
      ],
    },
    {
      key: 'prioridad',
      question: '¿Cuál es tu prioridad principal al elegir el guante?',
      options: [
        { label: 'El precio más bajo', value: 'precio' },
        { label: 'El mejor equilibrio precio-calidad', value: 'equilibrio' },
        { label: 'La máxima protección', value: 'proteccion' },
      ],
    },
  ];

  // Scoring matrix: how many points each product earns per answer. Handles must match the
  // real Shopify product handles rendered into the <script type="application/json"> tag.
  var SCORES = {
    'guante-de-nitrilo-azul-5-g': {
      light: 0, moderate: 3, heavy: 1,
      si: 2, no: 0,
      evitar: 2, 'no-problema': 1,
      precio: 0, equilibrio: 3, proteccion: 1,
    },
    'guante-de-nitrilo-negro-5-g': {
      light: 0, moderate: 3, heavy: 1,
      si: 2, no: 0,
      evitar: 2, 'no-problema': 1,
      precio: 0, equilibrio: 2, proteccion: 1,
    },
    'guante-de-nitrilo-naranja-8-g': {
      light: 0, moderate: 1, heavy: 5,
      si: 0, no: 3,
      evitar: 2, 'no-problema': 1,
      precio: 0, equilibrio: 1, proteccion: 4,
    },
    'guante-de-vinilo-azul': {
      light: 3, moderate: 1, heavy: 0,
      si: 2, no: 1,
      evitar: 2, 'no-problema': 1,
      precio: 3, equilibrio: 1, proteccion: 0,
    },
    'guante-de-latex-con-polvo': {
      light: 1, moderate: 2, heavy: 0,
      si: 2, no: 0,
      evitar: -5, 'no-problema': 3,
      precio: 0, equilibrio: 1, proteccion: 2,
    },
    'guante-hibrido-tpe': {
      light: 3, moderate: 0, heavy: 0,
      si: 2, no: 1,
      evitar: 2, 'no-problema': 1,
      precio: 4, equilibrio: 0, proteccion: 0,
    },
    'guante-de-polietileno-hdpe': {
      light: 3, moderate: 0, heavy: 0,
      si: 2, no: 0,
      evitar: 2, 'no-problema': 1,
      precio: 2, equilibrio: 1, proteccion: 0,
    },
    'guante-nitriblend': {
      light: 1, moderate: 2, heavy: 0,
      si: 2, no: 1,
      evitar: 2, 'no-problema': 1,
      precio: 3, equilibrio: 1, proteccion: 0,
    },
  };

  var REASONS = {
    'guante-de-nitrilo-azul-5-g':
      'Nitrilo de 5 g: buen equilibrio entre protección, comodidad y precio para manejo de alimentos día a día.',
    'guante-de-nitrilo-negro-5-g':
      'Nitrilo de 5 g en negro: la misma protección versátil que el azul, con una presentación distinta.',
    'guante-de-nitrilo-naranja-8-g':
      'Nitrilo de 8 g de alta resistencia: pensado para trabajo rudo y mayor durabilidad.',
    'guante-de-vinilo-azul':
      'Vinilo: opción económica y libre de látex, ideal para tareas cortas de manipulación de alimentos.',
    'guante-de-latex-con-polvo':
      'Látex con polvo: la mejor sensibilidad táctil, para cuando el látex no es un problema.',
    'guante-hibrido-tpe':
      'Híbrido TPE: muy económico y cómodo para uso ligero con cambio frecuente.',
    'guante-de-polietileno-hdpe':
      'Polietileno (HDPE): ideal para manipulación rápida de alimentos con cambios constantes de guante.',
    'guante-nitriblend':
      'Nitriblend: opción económica de nitrilo, libre de látex, para uso diario moderado.',
  };

  class GlovesQuiz extends HTMLElement {
    connectedCallback() {
      this.stageEl = this.querySelector('[data-ref="stage"]');
      this.nextBtn = this.querySelector('[data-ref="nextBtn"]');
      this.backBtn = this.querySelector('[data-ref="backBtn"]');
      this.restartBtn = this.querySelector('[data-ref="restartBtn"]');
      this.progressFill = this.querySelector('[data-ref="progressFill"]');
      this.progressEl = this.querySelector('[data-ref="progress"]');

      var dataScript = this.querySelector('[data-ref="productData"]');
      try {
        this.products = dataScript ? JSON.parse(dataScript.textContent) : {};
      } catch (e) {
        this.products = {};
      }

      this.answers = {};
      this.currentStep = 0;

      this.nextBtn.addEventListener('click', this.goNext.bind(this));
      this.backBtn.addEventListener('click', this.goBack.bind(this));
      this.restartBtn.addEventListener('click', this.restart.bind(this));

      this.renderQuestion();
    }

    updateProgress() {
      var pct = ((this.currentStep + 1) / QUESTIONS.length) * 100;
      if (this.progressFill) this.progressFill.style.width = pct + '%';
      if (this.progressEl) this.progressEl.setAttribute('aria-valuenow', String(this.currentStep + 1));
    }

    renderQuestion() {
      var question = QUESTIONS[this.currentStep];
      this.updateProgress();

      this.backBtn.hidden = this.currentStep === 0;
      this.restartBtn.hidden = true;
      this.nextBtn.hidden = false;
      this.nextBtn.textContent = this.currentStep === QUESTIONS.length - 1 ? 'Ver mi recomendación' : 'Siguiente';
      this.nextBtn.disabled = !this.answers[question.key];

      var html = '<p class="gloves-quiz__question">' + question.question + '</p>';
      html += '<div class="gloves-quiz__options" role="group">';
      question.options.forEach(
        function (option) {
          var isSelected = this.answers[question.key] === option.value;
          html +=
            '<button type="button" class="gloves-quiz__option" data-value="' +
            option.value +
            '" aria-pressed="' +
            (isSelected ? 'true' : 'false') +
            '">' +
            option.label +
            '</button>';
        }.bind(this)
      );
      html += '</div>';

      this.stageEl.innerHTML = html;

      var buttons = this.stageEl.querySelectorAll('.gloves-quiz__option');
      buttons.forEach(
        function (btn) {
          btn.addEventListener(
            'click',
            function () {
              this.answers[question.key] = btn.getAttribute('data-value');
              buttons.forEach(function (b) {
                b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
              });
              this.nextBtn.disabled = false;
            }.bind(this)
          );
        }.bind(this)
      );
    }

    goNext() {
      if (this.currentStep < QUESTIONS.length - 1) {
        this.currentStep++;
        this.renderQuestion();
      } else {
        this.showResult();
      }
    }

    goBack() {
      if (this.currentStep > 0) {
        this.currentStep--;
        this.renderQuestion();
      }
    }

    restart() {
      this.answers = {};
      this.currentStep = 0;
      this.renderQuestion();
    }

    computeScores() {
      var totals = {};
      Object.keys(SCORES).forEach(function (handle) {
        totals[handle] = 0;
      });

      Object.keys(this.answers).forEach(
        function (key) {
          var value = this.answers[key];
          Object.keys(SCORES).forEach(function (handle) {
            var deltas = SCORES[handle];
            if (deltas && typeof deltas[value] === 'number') {
              totals[handle] += deltas[value];
            }
          });
        }.bind(this)
      );

      return totals;
    }

    showResult() {
      var totals = this.computeScores();
      var ranked = Object.keys(totals)
        .filter(
          function (handle) {
            return this.products[handle];
          }.bind(this)
        )
        .sort(function (a, b) {
          return totals[b] - totals[a];
        });

      var topHandle = ranked[0];
      var secondHandle = ranked[1];

      this.backBtn.hidden = true;
      this.nextBtn.hidden = true;
      this.restartBtn.hidden = false;
      if (this.progressFill) this.progressFill.style.width = '100%';

      if (!topHandle) {
        this.stageEl.innerHTML =
          '<p class="gloves-quiz__question">No pudimos calcular una recomendación. Escríbenos y te ayudamos directamente.</p>';
        return;
      }

      var top = this.products[topHandle];
      var reason = REASONS[topHandle] || '';

      var html = '<div class="gloves-quiz__result">';
      html += '<p class="gloves-quiz__result-badge">Tu recomendación</p>';
      if (top.image) {
        html += '<img class="gloves-quiz__result-image" src="' + top.image + '" alt="' + top.title + '">';
      }
      html += '<p class="gloves-quiz__result-title">' + top.title + '</p>';
      html += '<p class="gloves-quiz__result-price">' + top.price + '</p>';
      html += '<p class="gloves-quiz__result-reason">' + reason + '</p>';
      html += '<a class="button" href="' + top.url + '">Ver producto</a>';

      if (secondHandle && this.products[secondHandle]) {
        var second = this.products[secondHandle];
        html +=
          '<p class="gloves-quiz__result-secondary">También podría interesarte: <a href="' +
          second.url +
          '">' +
          second.title +
          '</a></p>';
      }

      html += '</div>';

      this.stageEl.innerHTML = html;
    }
  }

  if (!customElements.get('gloves-quiz')) {
    customElements.define('gloves-quiz', GlovesQuiz);
  }
})();
